import React from 'react'

const NotFound = () => {
  return (
    <>
        <div className='uk-section uk-flex uk-flex-center uk-flex-middle uk-flex-column uk-height-viewport'>
          <div className='uk-container uk-text-center'>
            <div className='uk-heading-xlarge'> Oops! </div>
               <div className='uk-h1'> The page cant be found </div>

               <div> </div>
          </div>
        </div>
    </>

  )
}

export default NotFound